/**
 * Copyright (c) 2022 Yoshinobu Obata
 * Released under the Apache-2.0 license
 * LICENSE: http://www.apache.org/licenses/LICENSE-2.0
 */

const AvailableLocales = ['en', 'ja', 'ja-Hira'];

const Message = {
    categoryName: {
        'ja': '感情分析',
        'ja-Hira': 'かんじょうぶんせき',
        'en': 'Emotion Analysis',
    },
    emotion: {
        'ja': '「[WORDS]」 の感情',
        'ja-Hira': '「[WORDS]」 のかんじょう',
        'en': 'estimate emotion of "[WORDS]"',
    },
    emotionScore: {
        'ja': '「[WORDS]」 の [EMOTION] スコア',
        'ja-Hira': '「[WORDS]」 の [EMOTION] スコア',
        'en': '[EMOTION] score of "[WORDS]"',
    },
    emotionCondition: {
        'ja': '「[WORDS]」 の感情が [EMOTION]',
        'ja-Hira': '「[WORDS]」 のかんじょうが [EMOTION]',
        'en': 'emotion of "[WORDS]" is [EMOTION]',
    },
    modelStatus: {
        'ja': '感情分析モデルの状態',
        'ja-Hira': 'かんじょうぶんせきモデルのじょうたい',
        'en': 'emotion model status',
    },
    translationModelStatus: {
        'ja': '翻訳モデルの状態（共有）',
        'ja-Hira': 'ほんやくモデルのじょうたい（きょうゆう）',
        'en': 'translation model status (shared)',
    },
    loadingMessage: {
        'ja': 'モデル読み込み中...約3分お待ちください',
        'ja-Hira': 'モデルよみこみちゅう...やく3ふんおまちください',
        'en': 'Loading model... Please wait about 3 minutes',
    },
    modelNotReady: {
        'ja': '未ロード',
        'ja-Hira': 'みロード',
        'en': 'Not loaded',
    },
    modelLoading: {
        'ja': '読み込み中',
        'ja-Hira': 'よみこみちゅう',
        'en': 'Loading',
    },
    modelReady: {
        'ja': '準備完了',
        'ja-Hira': 'じゅんびかんりょう',
        'en': 'Ready',
    },
    modelError: {
        'ja': 'エラー',
        'ja-Hira': 'エラー',
        'en': 'Error',
    },
    emotionMenu: {
        joy: {
            'ja': '喜び',
            'ja-Hira': 'よろこび',
            'en': 'joy'
        },
        sadness: {
            'ja': '悲しみ',
            'ja-Hira': 'かなしみ',
            'en': 'sadness'
        },
        anger: {
            'ja': '怒り',
            'ja-Hira': 'いかり',
            'en': 'anger'
        },
        fear: {
            'ja': '恐れ',
            'ja-Hira': 'おそれ',
            'en': 'fear'
        },
        surprise: {
            'ja': '驚き',
            'ja-Hira': 'おどろき',
            'en': 'surprise'
        },
        disgust: {
            'ja': '嫌悪',
            'ja-Hira': 'けんお',
            'en': 'disgust'
        },
        neutral: {
            'ja': '中立',
            'ja-Hira': 'ちゅうりつ',
            'en': 'neutral'
        }
    }
};

/**
 * NLLB-200モデルの言語コード
 * 各言語のNLLB-200形式のコードを定義
 */
const LanguageCodes = {
    'english': 'eng_Latn',
    'japanese': 'jpn_Jpan',
    'chinese': 'zho_Hans',
    'korean': 'kor_Hang',
    'french': 'fra_Latn',
    'spanish': 'spa_Latn',
    'german': 'deu_Latn'
};

module.exports = {
    AvailableLocales,
    Message,
    LanguageCodes
};